export default __webpack_public_path__ + "static/media/logo-small-dark.12c611eb.webp";